import React, { useContext, useEffect, useRef } from 'react'
import { Context } from '@/components/Context'

const HeaderTestnet = () => {
    const { accountSignature, faucetHandler } = useContext(Context)
    const logoRef = useRef(null)

    useEffect(() => {
        const adjustScale = () => {
            const pageWidth = window.innerWidth
            let height: number

            if (pageWidth <= 610) {
                height = 135
            } else if (pageWidth > 400 && pageWidth <= 700) {
                height = 120
            } else if (pageWidth > 700 && pageWidth <= 1340) {
                height = 100
            } else {
                height = 50
            }
            if (logoRef.current) {
                // @ts-ignore
                logoRef.current.style.height = `${height}px`
                // @ts-ignore
                logoRef.current.style.transition = 'transform 1s ease-in-out' // Add this line
            }
        }

        adjustScale()

        window.addEventListener('resize', adjustScale)

        return () => window.removeEventListener('resize', adjustScale)
    }, [])

    return (
        <div ref={logoRef} className="testnet">
            <div className="testnet-container">
                <span>Testnet: </span>
                <span className="testnet-text small">
                    Please note this frontend is currently under development and running on Pulsechain v4 testnet where
                    PLSX is used to represent CRAZY.
                </span>
                <span className="testnet-text small">
                    Receive tPLS and tPLSX (CRAZY) from our faucet. Only empty wallets are eligible.
                    {accountSignature && (
                        <button type="button" className="nav__connect long-button" onClick={faucetHandler}>
                            Request from Faucet
                        </button>
                    )}
                </span>
            </div>
        </div>
    )
}

export default HeaderTestnet
